//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { formatterCurrency } from "../../../shared/utils";
import { TrackingContext } from "../context/TrackingContext";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerFlowCards() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { events, setEvents } = useContext(TrackingContext);



    useEffect(() => {

    }, []);







    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV DATA RESUME */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">


                {/* DIV DA RECEITA LÍQUIDA */}
                <div className="bg-surface-2 p-4 rounded-xl shadow border border-white/[0.16]">
                    <h2 className="text-ink-3 font-semibold mb-2 text-center"><b>Visitante → Checkout</b></h2>
                    {events.checkouts_por_visitantes ?
                        <div>
                            <h1 className="text-white font-semibold mb-1 text-center text-7xl"><b>{events.checkouts_por_visitantes}%</b></h1>
                            <p className="text-ink-3 font-semibold mb-1 text-center">{events.checkouts} de {events.visitantes}</p>
                        </div>
                        :
                        <i class="fas fa-circle-notch mt-5 fa-spin opacity-70 flex justify-center items-center text-7xl"></i>
                    }
                </div>


                {/* DIV DAS DESPESAS */}
                <div className="bg-surface-2 p-4 rounded-xl shadow border border-white/[0.16]">
                    <h2 className="text-ink-3 font-semibold mb-2 text-center"><b>Checkout → Compra</b></h2>
                    {events.vendas_por_checkouts ?
                        <div>
                            <h1 className="text-white font-semibold mb-1 text-center text-7xl"><b>{events.vendas_por_checkouts}%</b></h1>
                            <p className="text-ink-3 font-semibold mb-1 text-center">{events.vendas} de {events.checkouts}</p>
                        </div>
                        :
                        <i class="fas fa-circle-notch mt-5 fa-spin opacity-70 flex justify-center items-center text-7xl"></i>
                    }
                </div>


                {/* DIV DA RECEITA BRUTA */}
                <div className="bg-surface-2 p-4 rounded-xl shadow border border-white/[0.16]">
                    <h2 className="text-ink-3 font-semibold mb-2 text-center"><b>Visitante → Compra</b></h2>
                    {events.vendas_por_visitantes ?
                        <div>
                            <h1 className="text-white font-semibold mb-1 text-center text-7xl"><b>{events.vendas_por_visitantes}%</b></h1>
                            <p className="text-ink-3 font-semibold mb-1 text-center">{events.vendas} de {events.visitantes}</p>
                        </div>
                        :
                        <i class="fas fa-circle-notch mt-5 fa-spin opacity-70 flex justify-center items-center text-7xl"></i>
                    }
                </div>


            </div>

        </>
    )
}